import { Link } from 'react-router';

import { Button } from '@/components/Button/Button';
import { Card } from '@/components/Card/Card';

import styles from './ErrorScreen.module.css';

interface ErrorScreenProps {
  loginHref?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorScreen({
  loginHref,
  message,
  onRetry,
}: ErrorScreenProps) {
  return (
    <div className={styles.shell}>
      <Card className={styles.card} role="alert" variant="elevated">
        <h1 className={styles.title}>Something went wrong</h1>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          {onRetry ? (
            <Button onClick={onRetry} variant="primary">
              Retry
            </Button>
          ) : null}
          {loginHref ? (
            <Button as={Link} to={loginHref} variant="secondary">
              Go to login
            </Button>
          ) : null}
        </div>
      </Card>
    </div>
  );
}
